import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import { Box, Button } from '@mui/material/';
import { createUserWithEmailAndPassword, updateProfile, signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { uds } from "../services/userservices";

function validateEmail(input) {

    var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (input.match(validRegex)) {
        return true;
    } else {
        return false;
    }
}

export default function RegistrationInputs() {
    const [usr, setUser] = useState('');
    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');

    const [usrFocus, setUsrFocus] = useState(undefined);
    const [usrColor, setUsrColor] = useState(undefined);

    const [emailLabel, setEmailLabel] = useState("Email");
    const [emailFocus, setEmailFocus] = useState(undefined);
    const [emailColor, setEmailColor] = useState(undefined);

    const [passFocus, setPassFocus] = useState(undefined);
    const [passColor, setPassColor] = useState(undefined);

    const navigate = useNavigate();

    const handleUserChange = (event) => {
        const inputValue = event.target.value
        setUser(inputValue.toString());
    };

    const handleEmailChange = (event) => {
        const inputValue = event.target.value
        setEmail(inputValue.toString());
    };

    const handlePassChange = (event) => {
        const inputValue = event.target.value
        setPass(inputValue.toString());
    };

    const handleFormSubmit = async () => {
        setPassFocus(undefined);
        setPassColor(undefined);
        setUsrFocus(undefined);
        setUsrColor(undefined);
        setEmailLabel("Email");
        setEmailFocus(undefined);
        setEmailColor(undefined);
        if (usr.length === 0) {
            setUsrFocus(true);
            setUsrColor("warning");
        } else if (pass.length === 0) {
            setPassFocus(true);
            setPassColor("warning");
        }
        else if (!validateEmail(email)) {
            setEmailLabel("Please Enter Valid Email");
            setEmailFocus(true);
            setEmailColor("warning");
        } else {

            createUserWithEmailAndPassword(auth, email, pass)
            .then((userCredential) => {
                // Signed up 
                const user = userCredential.user;
                uds.createUser(user.uid, email);
                console.log(`${email} registered as new user`);

                signInWithEmailAndPassword(auth, email, pass)
                .then((userCredential) => {

                    // Signed in 
                    updateProfile(auth.currentUser, {
                        displayName: usr
                    }).then(() => {
                        console.log(`${auth.currentUser.displayName} signed in`);
                        navigate('/');
                    }).catch((error) => {
                        console.log(error);
                    });

                })
                .catch((error) => {
                    console.log(error);
                });
                
            })
            .catch((error) => {
                console.log(error);
            });
        }
        
    };

    return (
        <Box m={2}>
            <Box mb={2}>
                <TextField
                    label="Username"
                    type="text"
                    placeholder="Enter New Username"
                    value={usr}
                    onChange={handleUserChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    focused={usrFocus}
                    color={usrColor}
                />
            </Box>
            <Box mb={2}>
                <TextField
                    label={emailLabel}
                    type="text"
                    placeholder="Enter New Email"
                    value={email}
                    onChange={handleEmailChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    focused={emailFocus}
                    color={emailColor}
                />
            </Box>
            <Box mb={2}>
                <TextField
                    label="Password"
                    type="password"
                    placeholder="Enter New Password"
                    value={pass}
                    onChange={handlePassChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    focused={passFocus}
                    color={passColor}
                />
            </Box>
            <Button variant="contained" onClick={handleFormSubmit}>
                Register
            </Button>
        </Box>
    );
}